import * as actionTypes from "../Subscription/actionTypes";

export function setFresh(key) {
  return dispatch => {
    dispatch({
      type: actionTypes.SUBSCRIPTION_NOTIFICATION,
      [key]: {
        stale: false
      }
    });
  };
}



// WEBPACK FOOTER //
// ./app/modules/Subscription/actions.js